export default "__VITE_ASSET__BvY4TPqd__"